import React from 'react';
import {classNamesPrefixed} from '../../../helpers/Helpers';

export const Icon = (props) => {
    const {name, className, value} = props;
    let {type} = props;
    if (!type){
        type = "fa";
    }

    if (name) {
        return (
            <i
                className={classNamesPrefixed({
                    [type]: true,
                    ['fa-' + name]: true,
                    [className]: true
                })}
                value={value}
            />
        );
    } else {
        return null;
    }
};


// WEBPACK FOOTER //
// ./src/components/backend/UI/Icon.js